<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <MessageForm
          v-model="message"
          title="Nová zpráva"
          :loading="saving"
          :edit="false"
          @save="save"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import MessageForm from '@/components/forms/MessageForm.vue'

export default {
  name: 'MessageAdd',
  components: {
    MessageForm,
  },
  data() {
    return {
      message: {},
      loading: false,
      saving: false,
    }
  },
  methods: {
    ...mapActions({
      createMessage: 'message/createMessage',
    }),
    save() {
      this.saving = true
      this.createMessage(this.message)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            this.$router.push({
              name: 'messages',
            })
          }
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>
